import React from 'react';
import ChatPanel from 'app/Configs/fuse-layouts/shared-components/chatPanel/ChatPanel';
import QuickPanel from 'app/Configs/fuse-layouts/shared-components/quickPanel/QuickPanel';

const RightSideLayout2 = () => {
    return (
        <React.Fragment>

            <ChatPanel/>

            <QuickPanel/>
        </React.Fragment>
    );
};

export default RightSideLayout2;
